export const isNotEmpty = (value: string) => value.trim().length !== 0;
export const isTruthyAndNotEmpty = (value: string | undefined | null) =>
  !!value && (value?.trim()?.length ?? 0) > 0;
export const isOptionEqualsValue = (option: string, value: string) => option === value;
export const removeQuotationMarksFrom = (value: string) => value.replaceAll('"', "");
export const distinctStringItems = (values: string[] | undefined) => {
  if (!values) return [];

  const stringSet = new Set<string>();
  values.forEach((value) => stringSet.add(value));
  return Array.from(stringSet);
};
